import type { MsgType } from '@/lib/order-storage'
import { formatOrderCustomerName, isDbsOrder } from '@/lib/order-helpers'
import type { MessageDispatch, YMarketOrder } from '@/lib/types'
import type { ChatSendOrigin } from '@/lib/chat-motion'
import { DbsDetail, type DbsDetailProps } from '@/components/orders/DbsDetail'
import { FbsDetail } from '@/components/orders/FbsDetail'
import { OrderDetailHeader } from '@/components/orders/OrderDetailHeader'

type SharedDbsProps = Omit<DbsDetailProps, 'order'>

function defaultDbsProps(order: YMarketOrder, messageStates: MessageDispatch[]): SharedDbsProps {
  return {
    buyerName: formatOrderCustomerName(order, null),
    nameParts: [],
    greetingNameIdx: null,
    manualShipDate: '',
    manualShipTime: '',
    manualTrack: '',
    cdekEstimate: null,
    cdekTracking: null,
    returnCdekTracking: null,
    returnCdekTrackingLoading: false,
    messageStates,
    copied: false,
    copiedFirst: false,
    copiedCourier: false,
    sendingType: null,
    markingManual: null,
    sendError: '',
    isReady: false,
    handoffAccepted: false,
    missingFields: [],
    templateText: null,
    firstMessageText: null,
    firstMsgMissing: [],
    courierMessageText: null,
    chatHistory: null,
    chatLoading: false,
    chatError: '',
    chatOpen: false,
    pendingChatDelivery: null,
    chatSendFlight: null,
    onChatOpenChange: () => undefined,
    onChatSendFlightComplete: () => undefined,
    onRefreshChat: () => undefined,
    onShipDateChange: () => undefined,
    onShipTimeChange: () => undefined,
    onTrackChange: () => undefined,
    onGreetingPartChange: () => undefined,
    onCopy: () => undefined,
    onCopyFirst: () => undefined,
    onCopyCourier: () => undefined,
    onSendFirst: (_origin: ChatSendOrigin) => undefined,
    onSendConfirm: (_origin: ChatSendOrigin) => undefined,
    onSendCourier: (_origin: ChatSendOrigin) => undefined,
    onToggleManualMark: (_kind: MsgType) => undefined,
  }
}

export function OrderDetailContent({ order, messageStates, dbsProps }: {
  order: YMarketOrder
  messageStates: MessageDispatch[]
  dbsProps?: SharedDbsProps
}) {
  return (
    <>
      <OrderDetailHeader order={order} messageStates={messageStates} />
      {isDbsOrder(order) ? <DbsDetail {...defaultDbsProps(order, messageStates)} {...dbsProps} order={order} /> : <FbsDetail order={order} />}
    </>
  )
}
